export default __webpack_public_path__ + "static/media/B226.2bbdbc61.png";